<template>
  <div :class="containerClass" @click="onWrapperClick">
    <AppTopBar @menu-toggle="onMenuToggle" />

    <transition name="layout-sidebar">
      <div
        :class="sidebarClass"
        @click="onSidebarClick"
        v-show="isSidebarVisible()"
      >
        <div class="layout-logo">
          <router-link to="/">
            <p
              style="
                color: white;
                font-family: sans-serif;
                font-size: 20px;
                font-weight: bold;
              "
              v-if="user.outlet_id == 0 && user.warehouse_id != 0"
            >
              {{ warehouse }}
            </p>
            <p
              style="
                color: white;
                font-family: sans-serif;
                font-size: 20px;
                font-weight: bold;
              "
              v-else-if="user.outlet_id != 0"
            >
              {{ outlet }}
            </p>
            <p
              style="
                color: white;
                font-family: sans-serif;
                font-size: 20px;
                font-weight: bold;
              "
              v-else
            >
              POINT OF SALES
            </p>
          </router-link>
        </div>

        <AppProfile />
        <!-- outlet manager menu -->
        <AppMenu
          :model="menuOutletManager"
          @menuitem-click="onMenuItemClick"
          v-if="user.role == 'OUTLET_MANAGER'"
        />
        <!-- purcahsing menu -->
        <AppMenu
          :model="normalPurchasing"
          @menuitem-click="onMenuItemClick"
          v-if="user.role == 'PURCHASING'"
        />

        <AppMenu
          :model="menuPurchasing"
          @menuitem-click="onMenuItemClick"
          v-if="user.role == 'MAIN_PURCHASING'"
        />
        <!-- finance menu -->
        <AppMenu
          :model="menuFinance"
          @menuitem-click="onMenuItemClick"
          v-if="user.role == 'FINANCE'"
        />
        <!-- werehouse menu -->
        <AppMenu
          :model="menuWarehouseManager"
          @menuitem-click="onMenuItemClick"
          v-if="user.role == 'WAREHOUSE_MANAGER'"
        />
        <!-- opname cashier menu -->
        <AppMenu
          :model="menuOpnameCashier"
          @menuitem-click="onMenuItemClick"
          v-if="user.role == 'STOCK_OPNAME'"
        />
        <!-- return menu -->
        <AppMenu
          :model="menuReturn"
          @menuitem-click="onMenuItemClick"
          v-if="user.role == 'RETURN'"
        />
        <!-- distribution menu -->
        <AppMenu
          :model="menuDistribution"
          @menuitem-click="onMenuItemClick"
          v-if="user.role == 'DISTRIBUTION'"
        />
        <!-- werehouse stok opname menu -->
        <AppMenu
          :model="menuStockOpname"
          @menuitem-click="onMenuItemClick"
          v-if="user.role == 'WAREHOUSE_STOCK_OPNAME'"
        />
        <!-- super admin menu -->
        <AppMenu
          :model="menuSuperAdmin"
          @menuitem-click="onMenuItemClick"
          v-if="user.role == 'SUPER_ADMIN'"
        />
      </div>
    </transition>

    <div class="layout-main">
      <Breadcrumb />
      <router-view />
    </div>

    <AppFooter />
  </div>
</template>

<script>
import AppTopBar from '../AppTopbar.vue'
import AppProfile from '../AppProfile.vue'
import AppMenu from '../AppMenu.vue'
import AppFooter from '../AppFooter.vue'
import Breadcrumb from '../components/Breadcrumb.vue'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      layoutMode: 'static',
      layoutColorMode: 'dark',
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      outlet: null,
      warehouse: null,

      menuWarehouseManager: [
        { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
        // {
        //   label: 'Employee',
        //   icon: 'pi pi-fw pi-users',
        //   to: '/employee/list'
        // },
        {
          label: 'Katalog',
          icon: 'pi pi-inbox',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-list',
              to: '/catalog/list'
            }
          ]
        },
        {
          label: 'Supplier',
          icon: 'pi pi-fw pi-users',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-fw pi-plus',
              to: '/supplier/list'
            }
          ]
        },
        {
          label: 'Kategori',
          icon: 'pi pi-fw pi-th-large',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-fw pi-plus',
              to: '/category/list'
            }
          ]
        },
        {
          label: 'Laporan Barang',
          icon: 'pi pi-fw pi-briefcase',
          items: [
            {
              label: 'Laporan Mutasi Keluar',
              icon: 'pi pi-fw pi-print',
              to: '/report/mutation-out-list'
            },
            {
              label: 'Laporan Mutasi Per Supplier',
              icon: 'pi pi-fw pi-print',
              to: '/report/mutation-per-supplier'
            },
            {
              label: 'Laporan Stok Barang',
              icon: 'pi pi-fw pi-print',
              to: '/report/stock-warehosue'
            }
          ]
        },
        {
          label: 'Outlet',
          icon: 'pi pi-list',
          to: '/outlet/list'
        },
        {
          label: 'Pembelian',
          icon: 'pi pi-fw pi-shopping-cart',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-fw pi-plus',
              to: '/purchase/list'
            }
          ]
        },
        {
          label: 'Transfer Barang',
          icon: 'pi pi-fw pi-inbox',
          items: [
            {
              label: 'List Transfer',
              icon: 'pi pi-fw pi-list',
              to: '/purchasing-receive/list'
            },
            {
              label: 'List Penerimaan Barang',
              icon: 'pi pi-fw pi-list',
              to: '/purchasing-receive/list-destination'
            }
          ]
        },
        {
          label: 'Retur Supplier',
          icon: 'pi pi-fw pi-inbox',
          items: [
            {
              label: 'List Retur',
              icon: 'pi pi-fw pi-list',
              to: '/supplier-retur/list'
            }
          ]
        }
      ],

      normalPurchasing: [
        { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
        {
          label: 'Pembelian',
          icon: 'pi pi-fw pi-shopping-cart',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-fw pi-plus',
              to: '/purchase/list'
            }
          ]
        },
        {
          label: 'Katalog',
          icon: 'pi pi-inbox',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-list',
              to: '/catalog/list'
            }
          ]
        },
        {
          label: 'Supplier',
          icon: 'pi pi-fw pi-users',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-fw pi-plus',
              to: '/supplier/list'
            }
          ]
        },
        {
          label: 'Laporan Mutasi Per Supplier',
          icon: 'pi pi-fw pi-print',
          to: '/report/mutation-per-supplier'
        }
      ],

      menuPurchasing: [
        { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
        {
          label: 'Pembelian',
          icon: 'pi pi-fw pi-shopping-cart',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-fw pi-plus',
              to: '/purchase/list'
            }
          ]
        },
        {
          label: 'Transfer Barang',
          icon: 'pi pi-fw pi-inbox',
          items: [
            {
              label: 'List Transfer',
              icon: 'pi pi-fw pi-list',
              to: '/purchasing-receive/list'
            },
            {
              label: 'List Penerimaan Barang',
              icon: 'pi pi-fw pi-list',
              to: '/purchasing-receive/list-destination'
            }
          ]
        },
        {
          label: 'Supplier',
          icon: 'pi pi-fw pi-users',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-fw pi-plus',
              to: '/supplier/list'
            }
          ]
        },
        {
          label: 'Retur Supplier',
          icon: 'pi pi-fw pi-inbox',
          items: [
            {
              label: 'Create Retur Supplier',
              icon: 'pi pi-fw pi-plus',
              to: '/supplier-retur/create'
            },
            {
              label: 'List Retur Supplier',
              icon: 'pi pi-fw pi-list',
              to: '/supplier-retur/list'
            }
          ]
        },
        {
          label: 'Retur Supplier Feedback',
          icon: 'pi pi-fw pi-thumbs-up',
          items: [
            {
              label: 'Create Retur Supplier Feedback',
              icon: 'pi pi-fw pi-plus',
              to: '/supplier-retur-feedback/create'
            },
            {
              label: 'List Retur Supplier Feedback',
              icon: 'pi pi-fw pi-list',
              to: '/supplier-retur-feedback/list'
            }
          ]
        }
      ],
      menuFinance: [
        { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
        {
          label: 'Gross profit',
          icon: 'pi pi-fw pi-chart-bar',
          to: '/gross-profit/list'
        },
        {
          label: 'Expense',
          icon: 'pi pi-fw pi-reply',
          to: '/expense/list'
        }
      ],

      menuDistribution: [
        { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
        {
          label: 'Mutasi Barang',
          icon: 'pi pi-fw pi-briefcase',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-fw pi-list',
              to: '/item-mutation/list'
            },
            {
              label: 'Buat',
              icon: 'pi pi-fw pi-plus',
              to: '/item-mutation/create'
            },
            {
              label: 'Barcode',
              icon: 'pi pi-fw pi-align-justify',
              to: '/item-mutation/barcode'
            },
            {
              label: 'Bon',
              icon: 'pi pi-fw pi-file',
              to: '/item-mutation/bon'
            },
            {
              label: 'Barcode Sisa',
              icon: 'pi pi-fw pi-bookmark',
              to: '/item-mutation/remaining-bon'
            },
            {
              label: 'Cetak Ulang Barcode',
              icon: 'pi pi-fw pi-ticket',
              to: '/item-mutation/Reprint'
            }
          ]
        },
        {
          label: 'Mutasi Harga',
          icon: 'pi pi-fw pi-money-bill',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-fw pi-list',
              to: '/price-mutation/list'
            },
            {
              label: 'Buat',
              icon: 'pi pi-fw pi-plus',
              to: '/price-mutation/create'
            },
            {
              label: 'Generate Barcode',
              icon: 'pi pi-fw pi-bars',
              to: '/price-mutation/barcode'
            },
            {
              label: 'Generate Bon',
              icon: 'pi pi-fw pi-file',
              to: '/price-mutation/bon'
            }
          ]
        },
        {
          label: 'Bon Toko',
          icon: 'pi pi-fw pi-file',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-fw pi-list',
              to: '/bon/list'
            }
          ]
        }
      ],

      menuStockOpname: [
        { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
        {
          label: 'Stock Opname',
          icon: 'pi pi-fw pi-briefcase',
          items: [
            {
              label: 'Buat',
              icon: 'pi pi-fw pi-plus',
              to: '/stock-opname/create'
            },
            {
              label: 'Review',
              icon: 'pi pi-fw pi-file',
              to: '/stock-opname/review'
            },
            {
              label: 'List',
              icon: 'pi pi-list',
              to: '/stock-opname/list'
            }
          ]
        },
        {
          label: 'Katalog',
          icon: 'pi pi-fw pi-shopping-cart',
          to: '/catalog/list'
        }
      ],

      menuOpnameCashier: [
        { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
        {
          label: 'Katalog',
          icon: 'pi pi-fw pi-shopping-cart',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-fw pi-list',
              to: '/catalog/list'
            }
          ]
        }
      ],

      menuReturn: [
        { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
        {
          label: 'Retur Barang',
          icon: 'pi pi-fw pi-list',
          to: '/receiving-warehouse/list'
        },

        {
          label: 'Transfer Barang',
          icon: 'pi pi-fw pi-inbox',
          items: [
            {
              label: 'List Transfer',
              icon: 'pi pi-fw pi-list',
              to: '/warehouse-transfer/list'
            },
            {
              label: 'Buat Transfer',
              icon: 'pi pi-fw pi-plus',
              to: '/warehouse-transfer/create'
            }
          ]
        },

        {
          label: 'Permintaan Barang Obral',
          icon: 'pi pi-fw pi-tags',
          items: [
            {
              label: 'Buat',
              icon: 'pi pi-fw pi-plus',
              to: '/obral/create'
            },
            {
              label: 'Daftar',
              icon: 'pi pi-fw pi-list',
              to: '/obral/list'
            }
          ]
        },
        {
          label: 'Barang Obral',
          icon: 'pi pi-fw pi-inbox',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-fw pi-list',
              to: '/obral/item'
            }
          ]
        },
        {
          label: 'Stock',
          icon: 'pi pi-fw pi-check-square',
          items: [
            {
              label: 'Import',
              icon: 'pi pi-fw pi-arrow-circle-down',
              to: '/stock/import'
            }
          ]
        }
      ],

      menuOutletManager: [
        { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
        {
          label: 'Pramuniaga',
          icon: 'pi pi-user',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-plus',
              to: '/pramuniaga/list'
            }
          ]
        },
        {
          label: 'Pelanggan',
          icon: 'pi pi-users',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-user-plus',
              to: '/customer/list'
            }
          ]
        },
        {
          label: 'Katalog',
          icon: 'pi pi-inbox',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-list',
              to: '/catalog/list'
            }
            // {
            //   label: 'Tambah Item',
            //   icon: 'pi pi-plus-circle',
            //   to: '/catalog/item'
            // }
          ]
        },
        {
          label: 'Penerimaan Barang',
          icon: 'pi pi-align-justify',
          items: [
            {
              label: 'Buat',
              icon: 'pi pi-plus-circle',
              to: '/receiving/create'
            },
            {
              label: 'Daftar',
              icon: 'pi pi-list',
              to: '/receiving/list'
            }
          ]
        },
        {
          label: 'Retur',
          icon: 'pi pi-spinner',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-list',
              to: '/outgoing/list'
            },
            {
              label: 'List Detail Retur',
              icon: 'pi pi-bars',
              to: '/outgoing/list-detail'
            },
            {
              label: 'Buat Retur Obral',
              icon: 'pi pi-plus-circle',
              to: '/outgoing/create'
            },
            {
              label: 'Buat Retur Supplier',
              icon: 'pi pi-plus-circle',
              to: '/outgoing/create/supplier'
            },
            {
              label: 'Buat Retur Pemutihan',
              icon: 'pi pi-plus-circle',
              to: '/outgoing/create/pemutihan'
            },
            {
              label: 'Buat Retur Kelebihan',
              icon: 'pi pi-plus-circle',
              to: '/outgoing/create/kelebihan'
            },
            {
              label: 'Buat Retur Kekurangan',
              icon: 'pi pi-plus-circle',
              to: '/outgoing/create/kekurangan'
            },
            {
              label: 'Transfer Item',
              icon: 'pi pi-external-link',
              to: '/outgoing/transfer'
            }
          ]
        },
        {
          label: 'Shift',
          icon: 'pi pi-sitemap',
          items: [
            {
              label: 'Daftar',
              icon: 'pi pi-plus',
              to: '/shift/list'
            }
          ]
        },
        {
          label: 'Laporan Omset',
          icon: 'pi pi-dollar',
          items: [
            {
              label: 'Daily Omset',
              icon: 'pi pi-chart-bar',
              to: '/omset/daily'
            },
            {
              label: 'Daily Omset by Category',
              icon: 'pi pi-sitemap',
              to: '/omset/daily-by-category'
            },
            {
              label: 'Temporary Omset',
              icon: 'pi pi-chart-line',
              to: '/omset/temporary'
            },
            {
              label: 'Recap Omset',
              icon: 'pi pi-clock',
              to: '/omset/recap'
            }
          ]
        },
        {
          label: 'Laporan Barang',
          icon: 'pi pi-briefcase',
          items: [
            {
              label: 'Laporan Stock Opname',
              icon: 'pi pi-list',
              to: '/report/stock-opname-outlet-list'
            },
            {
              label: 'Laporan Performa Penjualan',
              icon: 'pi pi-sort',
              to: '/report/sell-performance'
            },
            {
              label: 'Laporan Kondisi Stok Barang',
              icon: 'pi pi-eject',
              to: '/report/items-condition'
            },
            {
              label: 'Laporan Kelompok Barang',
              icon: 'pi pi-table',
              to: '/report/category'
            },
            {
              label: 'Laporan Pendataan Supplier',
              icon: 'pi pi-sign-in ',
              to: '/report/supplier-report'
            },
            {
              label: 'Laporan Usia Barang Per Kode Barang',
              icon: 'pi pi-table',
              to: '/report/items-age'
            },
            {
              label: 'Riwayat Stok Barang Per Tahun',
              icon: 'pi pi-chart-bar',
              to: '/report/stock-condition-per-year'
            },
            {
              label: 'Laporan Kelompok Barang Best Seller',
              icon: 'pi pi-tablet',
              to: '/report/category/best-seller'
            },
            {
              label: 'Laporan Akumulasi Penjualan Harian',
              icon: 'pi pi-chart-line',
              to: '/report/category/accumulation-selling'
            },
            {
              label: 'Laporan Akumulasi Penjualan Bulanan',
              icon: 'pi pi-clock',
              to: '/report/category/accumulation-selling-group'
            },
            {
              label: 'Laporan Stok Barang',
              icon: 'pi pi-th-large',
              to: '/report/barang'
            },
            {
              label: 'Laporan Barang Masuk Per Bon',
              icon: 'pi pi-table',
              to: '/report/item-inbound'
            },
            {
              label: 'Laporan Barang Masuk Per Bulan',
              icon: 'pi pi-table',
              to: '/report/item-per-month'
            },
            {
              label: 'Laporan Barang Masuk perbulan per kelompok barang',
              icon: 'pi pi-clone',
              to: '/report/group-item-per-month'
            },
            {
              label: 'Laporan Refund',
              icon: 'pi pi-reply',
              to: '/report/refund'
            }
          ]
        }
      ],
      menuSuperAdmin: [
        { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
        {
          label: 'Employee',
          icon: 'pi pi-user',
          to: '/employee/list'
        },
        {
          label: 'Voucher',
          icon: 'pi pi-money-bill',
          to: '/voucher/list'
        }
      ]
    }
  },
  watch: {
    $route() {
      this.menuActive = false
      this.$toast.removeAllGroups()
    },
    user: {
      immediate: true,
      handler() {
        if (
          this.user != undefined &&
          this.user.outlet_id != undefined &&
          this.user.outlet_id != 0
        ) {
          this.getOutlet()
        } else {
          this.getWarehouse()
        }
      }
    }
  },
  methods: {
    getOutlet() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/outlets/${this.user.outlet_id}`)
        .then(response => {
          if (response.status === 200) {
            this.outlet = response.data.data.outlets.name
          }
        })
    },

    getWarehouse() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/warehouses`)
        .then(response => {
          if (response.status === 200) {
            this.warehouse = response.data.data.warehouses
            // for each to get warehouse id same with user.warehouse_id
            this.warehouse.forEach(warehouse => {
              if (warehouse.id === this.user.warehouse_id) {
                this.warehouse = warehouse.name
              }
            })
          }
        })
    },

    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false
        this.mobileMenuActive = false
      }

      this.menuClick = false
    },
    onMenuToggle() {
      this.menuClick = true

      if (this.isDesktop()) {
        if (this.layoutMode === 'overlay') {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true
          }

          this.overlayMenuActive = !this.overlayMenuActive
          this.mobileMenuActive = false
        } else if (this.layoutMode === 'static') {
          this.staticMenuInactive = !this.staticMenuInactive
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive
      }

      event.preventDefault()
    },
    onSidebarClick() {
      this.menuClick = true
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false
        this.mobileMenuActive = false
      }
    },
    onLayoutChange(layoutMode) {
      this.layoutMode = layoutMode
    },
    onLayoutColorChange(layoutColorMode) {
      this.layoutColorMode = layoutColorMode
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className)
      else element.className += ' ' + className
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className)
      else
        element.className = element.className.replace(
          new RegExp(
            '(^|\\b)' + className.split(' ').join('|') + '(\\b|$)',
            'gi'
          ),
          ' '
        )
    },
    isDesktop() {
      return window.innerWidth > 1024
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === 'static') return !this.staticMenuInactive
        else if (this.layoutMode === 'overlay') return this.overlayMenuActive
        else return true
      } else {
        return true
      }
    }
  },
  computed: {
    ...mapState(['user', 'isAuthenticated']),
    containerClass() {
      return [
        'layout-wrapper',
        {
          'layout-overlay': this.layoutMode === 'overlay',
          'layout-static': this.layoutMode === 'static',
          'layout-static-sidebar-inactive':
            this.staticMenuInactive && this.layoutMode === 'static',
          'layout-overlay-sidebar-active':
            this.overlayMenuActive && this.layoutMode === 'overlay',
          'layout-mobile-sidebar-active': this.mobileMenuActive,
          'p-input-filled': this.$appState.inputStyle === 'filled',
          'p-ripple-disabled': this.$primevue.ripple === false
        }
      ]
    },
    sidebarClass() {
      return [
        'layout-sidebar',
        {
          'layout-sidebar-dark': this.layoutColorMode === 'dark',
          'layout-sidebar-light': this.layoutColorMode === 'light'
        }
      ]
    },
    logo() {
      return this.layoutColorMode === 'dark'
        ? require('@/assets/images/logo-white.svg')
        : require('@/assets/images/logo.svg')
    }
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, 'body-overflow-hidden')
    else this.removeClass(document.body, 'body-overflow-hidden')
  },
  components: {
    AppTopBar: AppTopBar,
    AppProfile: AppProfile,
    AppMenu: AppMenu,
    AppFooter: AppFooter,
    Breadcrumb
  }
}
</script>

<style lang="scss">
@import '../App.scss';
</style>
